import ContactRowLoadingComponent from './ContactRowLoading.component';

export default ContactRowLoadingComponent;
